<div class="rewards-list-tab">
  <div class="rewards-list-grid rewards-list-grid--loading" *ngIf="isLoadingRules">
    <div class="reward-rule-card-skeleton" *ngFor="let _ of skeletonCards"></div>
  </div>

  <div class="rewards-list-grid" *ngIf="showGrid">
    <app-reward-rule-card
      *ngFor="let rule of displayRules; trackBy: trackByRuleId"
      [rule]="rule"
      [packageNameById]="packageNameById"
      (editClick)="editRule.emit($event)"
      (disableClick)="onDisableRule($event)">
    </app-reward-rule-card>
  </div>

  <div class="empty-state-container" *ngIf="showEmptyState">
    <app-empty-result
      image="/assets/images/empty_screen.png"
      title="No rewards"
      description="Create a reward rule to get started."
      [showAction]="false">
    </app-empty-result>
  </div>
</div>

<app-confirmation-modal
  class="reward-disable-confirmation"
  [isVisible]="showDisableConfirmation"
  [data]="confirmationModalData"
  (cancel)="onDisableConfirmationCancel()"
  (confirm)="onDisableConfirmationConfirm()">
</app-confirmation-modal>
